import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import { TrainingsDataTableQuery } from 'generated/resources/datatable.graphql'
import compact from 'lodash/compact'

import useDataTable from 'modules/core/components/DataTable/hooks/useDataTable'
import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useUpdateCatalog } from 'modules/trainings/hooks/Trainings/useUpdateCatalog'

const BulkUpdateDisplayCatalog = () => {
  const { updateCatalog } = useUpdateCatalog()

  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const back = () => navigate(navigation.trainings.list.index.fullPath())
  const data = useDataTable<TrainingsDataTableQuery>()
  const selectedIds = compact(
    data.queryResult.data?.trainings.trainingsConnection.edges.map((training) => {
      if (data.selectedRows.has(String(training.node?.id))) {
        return training.node?.id
      }
    })
  )

  const description = i18n.t('trainings.update_catalog.description_add_bulk')

  const onSubmit = async () => {
    const response = await updateCatalog({ ids: selectedIds, catalog: true })
    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.update_catalog.error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.update_catalog.success'),
      })

      back()
    }
  }

  return (
    <Modal
      title={i18n.t('trainings.update_catalog.title')}
      description={description}
      onSubmit={onSubmit}
      onClose={back}
      footer={
        <>
          <Button.Router to={navigation.trainings.list.index.fullPath()}>
            {i18n.t('trainings.delete_training.cancel')}
          </Button.Router>
          <Button type="negative" submit>
            {i18n.t('trainings.delete_training.accept')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default BulkUpdateDisplayCatalog
